const routeSections = new Set([
  "agreement",
  "projects",
  "proposal",
  "rfq",
  "tasks",
])
const assignmentScopes = new Set(["owner", "supplier"])

export const getSpaceScopedReturnUrl = (
  value?: string | null,
): string | null => {
  if (!value) return null

  try {
    const url = new URL(value, "https://app.flextribe.io")
    const parts = url.pathname.split("/").filter(Boolean)
    const [section, second, third] = parts

    if (section === "projects" && second === "AI") {
      return null
    }

    if (routeSections.has(section) && second) {
      return `${url.pathname}${url.search}${url.hash}`
    }

    if (section === "assignment" && assignmentScopes.has(second) && third) {
      return `${url.pathname}${url.search}${url.hash}`
    }

    return null
  } catch {
    return null
  }
}
